import React from 'react'
import GlobalSelection from 'svg/SA/global-selection-os.svg'
import Satisfaction from 'svg/SA/satisfaction-guaranteed-os.svg'
import Reviews from 'svg/SA/5-star-reviews-os.svg'
import EmergingArtist from 'svg/SA/emerging-artist-os.svg'
export default [
  {
    icon: <GlobalSelection />,
    title: 'Global Selection',
    description: 'Explore a worldwide selection of original artwork for sale by thousands of artists.',
  },
  {
    icon: <Satisfaction />,
    title: 'Satisfaction Guaranteed',
    description: 'Our 14-day satisfaction guarantee allows you to buy with confidence.',
  },
  {
    icon: <Reviews />,
    title: 'Thousands of 5-Star Reviews',
    description: 'We deliver world-class customer service to all of our art buyers.',
  },
  {
    icon: <EmergingArtist />,
    title: 'Support Emerging Artists',
    description: 'We pay our artists more on every sale than other galleries.',
  },
]
